module.exports = __webpack_public_path__ + "static/img/shengshite-logo.fea5f5fc.png";